import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

export interface PageSizeDropdownProps {
  pageSize: number;
  pageSizes: number[];
  setPageSize(selected: number): void;
}
/**
 * PageSizeDropwdown
 *
 */
export const PageSizeDropdown = (props: Readonly<PageSizeDropdownProps>): JSX.Element => {
  const { pageSize, pageSizes, setPageSize } = props;
  const [open, setOpen] = useState(false);
  return (
    <React.Fragment>
      <Dropdown
        className="d-inline pl-2 pr-2"
        size="sm" isOpen={open}
        toggle={() => setOpen(!open)}>
          <DropdownToggle  caret >
            {pageSize}
          </DropdownToggle>
          <DropdownMenu>
            {pageSizes.map( size => (
              <DropdownItem
                key={size}
                onClick={() => setPageSize(size)}>
                    {size}
              </DropdownItem>
            ))}
          </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
}
PageSizeDropdown.displayName = 'PageSizeDropdown';
